import { Component, model, output } from '@angular/core';

@Component({
  selector: 'app-voucher-form',
  templateUrl: './voucher-form.component.html',
  styleUrl: './voucher-form.component.scss',
  standalone: false,
})
export class VoucherFormComponent {
  voucher = model<string | null>(null);
  hideVoucher = model(false);
  voucherApplied = output<{ voucher: string | null }>();

  applyVoucher(): void {
    this.voucherApplied.emit({ voucher: this.voucher() });
  }
}
